// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BranchesUI_view__ontzt {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.BranchesUI_loader__wMJ32 {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1;
}

.BranchesUI_hoursBtn__WG4q6 {
  margin-right: 20px;
  width: 200px;
  font-weight: 500;
  border-radius: 6px;
  font-size: 14px;
}

.BranchesUI_edit__2Hfx\\+,
.BranchesUI_delete__pDFue {
  cursor: pointer;
  margin-top: 3px;
}

.BranchesUI_actions__DqTUC {
  display: flex;
  align-items: center;
  justify-content: center;
}

.BranchesUI_divider__G3rbR {
  width: 1px;
  background-color: #c9c9c9;
  height: 22px;
  margin: 0 15px;
}

.BranchesUI_buttonBranch__dQPCt {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

@media (max-width: 768px) {
  .BranchesUI_buttonBranch__dQPCt {
    width: 100%;
    flex-direction: column;
    align-items: stretch;
  }

  .BranchesUI_buttonBranch__dQPCt button {
    width: 100% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/branches/styles/BranchesUI.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE;IACE,WAAW;IACX,sBAAsB;IACtB,oBAAoB;EACtB;;EACA;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".view {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.loader {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n}\n\n.hoursBtn {\n  margin-right: 20px;\n  width: 200px;\n  font-weight: 500;\n  border-radius: 6px;\n  font-size: 14px;\n}\n\n.edit,\n.delete {\n  cursor: pointer;\n  margin-top: 3px;\n}\n\n.actions {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.divider {\n  width: 1px;\n  background-color: #c9c9c9;\n  height: 22px;\n  margin: 0 15px;\n}\n\n.buttonBranch {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n@media (max-width: 768px) {\n  .buttonBranch {\n    width: 100%;\n    flex-direction: column;\n    align-items: stretch;\n  }\n  .buttonBranch button {\n    width: 100% !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"view": `BranchesUI_view__ontzt`,
	"loader": `BranchesUI_loader__wMJ32`,
	"hoursBtn": `BranchesUI_hoursBtn__WG4q6`,
	"edit": `BranchesUI_edit__2Hfx+`,
	"delete": `BranchesUI_delete__pDFue`,
	"actions": `BranchesUI_actions__DqTUC`,
	"divider": `BranchesUI_divider__G3rbR`,
	"buttonBranch": `BranchesUI_buttonBranch__dQPCt`
};
export default ___CSS_LOADER_EXPORT___;
